import styled from 'styled-components'
import { Card, Stepper as YogaStepper } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'
import { H2, H6 } from '@components/Text'

export const LaunchingWrapper = styled.section`
  padding-top: 20px;
  padding-bottom: 20px;
`

export const Title = styled(H2)`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  margin: 36px 0 0;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin: 60px 0 0;
  }
  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin: 34px 0 0 0;
  }
`

export const SubtitleWrapper = styled.section`
  display: flex;
  align-items: center;
  height: 100%;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    justify-content: flex-end;
  }
`

export const Subtitle = styled(H6)`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 16px 0 0;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin: 60px 0 0;
    font-size: 16px;
  }
`

export const StepperCard = styled(Card)`
  padding: 24px;
  margin-top: 32px;
  margin-bottom: 64px;
  overflow-x: scroll;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 40px;
    margin-bottom: 80px;
    overflow-x: auto;
  }
  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-bottom: 0;
  }
`

export const StepperWrapper = styled.section`
  margin-top: 24px;
  margin-bottom: 32px;
  width: 710px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    width: auto;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 32px;
    margin-bottom: 42px;
  }
`
export const Stepper = styled(YogaStepper)`
  div::after {
    background-color: ${tokens.colors.vibin};
  }

  div {
    div {
      div:nth-child(-n + 2) {
        div {
          background-color: ${tokens.colors.vibin} !important;
        }

        span {
          color: ${tokens.colors.vibin} !important;
        }
      }
    }
  }
`

export const Step = styled(YogaStepper.Step)``
